import { apiV2 } from 'api'
import { AxiosRequestConfig } from 'axios'

import { parseGetWorkspaceConfigurationResponse } from './schemas'
import type { GetWorkspaceConfigurationResponse } from './types'

export const getWorkspaceConfiguration = async (
  workspaceId: string,
  config?: AxiosRequestConfig
): Promise<GetWorkspaceConfigurationResponse> => {
  const { data } = await apiV2.get<unknown>(`/workspaces/${workspaceId}/configuration`, {
    ...config
  })

  return parseGetWorkspaceConfigurationResponse(data)
}

export {
  getMockLegacyWorkspaceConfiguration,
  getMockNamedPolicyWorkspaceConfiguration,
  getMockWorkspaceConfiguration
} from './fixtures'
export { parseGetWorkspaceConfigurationResponse } from './schemas'
export {
  getWorkspaceConfigurationDownloadLinkExpiresInSeconds,
  hasWorkspaceConfiguration,
  isAttestationEnabledForActivePolicy,
  isNamedPolicyWorkspaceConfiguration,
  isAutoSharingOnApprovalEnabledForWorkspaceConfiguration
} from './utils'
export type {
  ConfigurationPublicViewV2,
  ConfigurationPublicViewV3,
  GetWorkspaceConfigurationResponse,
  WorkspaceConfigurationForm
} from './types'
export { AirlockFormType } from './types'
